import React from 'react'; 
import PropTypes from 'prop-types'; 

import Image from '../../elements/Image';

import './style.scss'; 

function Clients(props) { 
  const { companies } = props; 

  return (
    <div className="clients-container container"> 
      <div className="logo-container row g-0"> 
        { companies.map((c, i) => {
          return (
            <div key={c.name} className="logo col-lg-2 col-4 mb-lg-0 mt-lg-0 mb-4 mt-4"> 
              <Image src={c.image} alt={c.name} /> 
            </div> 
          )
        })}
      </div> 
    </div> 
  );
} 

Clients.propTypes = {
  companies:  PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Clients; 
